var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuex-table',{attrs:{"fields":_vm.fields,"show_per_page":false,"auto_start":false,"foot_clone":true,"no_footer_sorting":true,"table_store":"mailer/archived_stats/general"}})}
var staticRenderFns = []

export { render, staticRenderFns }